import {
	createSlice,
	PayloadAction,
} from '@reduxjs/toolkit';
import {
	CompanyManagerResult,
	CompanyManagersState,
} from '@localTypes/companyManagers';

const initialState: CompanyManagersState = {};

export const companyManagersSlice = createSlice({
	initialState,
	name: 'company_managers',
	reducers: {
		clearCompanyManagers: (state, action: PayloadAction<number>) => {
			const companyId = action.payload;
			delete state[companyId];
		},
		setCompanyManagers: (state, action: PayloadAction<{
			companyId: number;
			result: CompanyManagerResult['result'];
			total: number;
		}>) => {
			const {
				companyId,
				result,
				total,
			} = action.payload;
			state[companyId] = {
				isError: false,
				isLoading: false,
				result,
				total,
			};
		},
		setCompanyManagersError: (state, action: PayloadAction<{
			companyId: number;
			isError: boolean;
		}>) => {
			const {
				companyId,
				isError,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isError = isError;
		},
		setCompanyManagersLoading: (state, action: PayloadAction<{
			companyId: number;
			isLoading: boolean;
		}>) => {
			const {
				companyId,
				isLoading,
			} = action.payload;
			if (!state[companyId]) {
				state[companyId] = {
					isError: false,
					isLoading: false,
					result: [],
					total: 0,
				};
			}
			state[companyId].isLoading = isLoading;
		},
	},
});

export const {
	clearCompanyManagers,
	setCompanyManagers,
	setCompanyManagersError,
	setCompanyManagersLoading,
} = companyManagersSlice.actions;

export const companyManagersReducer = companyManagersSlice.reducer;
